import { render, staticRenderFns } from "./RetirementRequested.vue?vue&type=template&id=3c2ce40e&"
import script from "./RetirementRequested.vue?vue&type=script&lang=js&"
export * from "./RetirementRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports